import { Pill } from '@hapvida/hapvida-core-components';

import {
  BENEFICIARY_TYPE_COLOR,
  BENEFICIARY_TYPE_NAME,
  BeneficiaryTypeEnum,
} from '@constants';

const beneficiaryTypeFilters = [
  {
    label: 'Titular',
    value: BeneficiaryTypeEnum.HOLDER,
    content: (
      <Pill
        color={BENEFICIARY_TYPE_COLOR[BeneficiaryTypeEnum.HOLDER]}
        text={BENEFICIARY_TYPE_NAME[BeneficiaryTypeEnum.HOLDER]}
        rounded={false}
      />
    ),
  },
  {
    label: 'Responsável sem direito',
    value: BeneficiaryTypeEnum.RESPONSIBLE,
    content: (
      <Pill
        color={BENEFICIARY_TYPE_COLOR[BeneficiaryTypeEnum.RESPONSIBLE]}
        text={BENEFICIARY_TYPE_NAME[BeneficiaryTypeEnum.RESPONSIBLE]}
        rounded={false}
      />
    ),
  },
  {
    label: 'Dependente',
    value: BeneficiaryTypeEnum.DEPENDENT,
    content: (
      <Pill
        color={BENEFICIARY_TYPE_COLOR[BeneficiaryTypeEnum.DEPENDENT]}
        text={BENEFICIARY_TYPE_NAME[BeneficiaryTypeEnum.DEPENDENT]}
        rounded={false}
      />
    ),
  },
];

const reviewBeneficiariesFilters = [
  {
    content: <span>Exibir apenas críticas</span>,
    label: 'Crítica',
    value: 'true',
  },
];

export { beneficiaryTypeFilters, reviewBeneficiariesFilters };
